import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authApi } from "./api";
import { tokenStore } from "./token-store";
import type { LoginInput } from "./types";

export const authKeys = {
  me: ["auth", "me"] as const,
};

/**
 * Current authenticated user, or null when signed out.
 * Server state via TanStack Query — there is no separate auth context;
 * this query IS the auth state.
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: authKeys.me,
    queryFn: authApi.me,
    retry: false,
    staleTime: 5 * 60_000,
  });
}

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: LoginInput) => authApi.login(input),
    onSuccess: ({ user, accessToken }) => {
      tokenStore.set(accessToken);
      queryClient.setQueryData(authKeys.me, user);
    },
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.logout,
    onSettled: () => {
      tokenStore.set(null);
      queryClient.setQueryData(authKeys.me, null);
      queryClient.clear();
    },
  });
}
